import http from "./httpClient";

export const getProfile = async () => {
  const { data } = await http.get(`/api/v1/profile`);
  return data;
}

export const sendInvoiceRequest = async (payload) => {
  const { data } = await http.post(`/api/v1/request`, payload);
  return data;
}

export const getPreSignedUrl = async (content_type, filename) => {
  const { data } = await http.post(`/api/v1/file/pre-signed-url`, {
        content_type, filename
      }
  );
  return data;
}

export const getInvoiceList = async (date_from, date_to) => {
    const { data } = await http.get('/api/v1/monitor/request/list', {
        params: { date_from, date_to },
    });
    return data;
};

export const getInvoiceListApiVersion = async (date_from, date_to) => {
    const { data } = await http.get('/api/v1/request', {
        params: { date_from, date_to },
    });
    return data;
};


export const getResult = async (id) => {
    const { data } = await http.get(`/api/v1/request/${id}`);
    return data;
}

export const getFullRequest = async (id) => {
    const { data } = await http.get(`/api/v1/monitor/request/${id}/full`);
    return data;
}



export const getQueueCount = async () => {
    const { data } = await http.get(`/api/v1/maintenance/queue-count`);
    return data;
}

export const getErrors = async (id) => {
    const { data } = await http.get(`/api/v1/monitor/request/${id}/errors`);
    return data;
}

export const getSteps = async (id) => {
    const { data } = await http.get(`/api/v1/monitor/request/${id}/steps`);
    return data;
}

export const getTempFileLinks = async (id) => {
    const { data } = await http.get(`/api/v1/monitor/request/${id}/temporary_file_links`);
    return data;
}


export const createIndices = async () => {
    const { data } = await http.post(`/api/v1/maintenance/db/create-indices`);
    return data;
}
